import { ControlBaseComponent } from '../control-base/control-base.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { StateService } from '../../../services/state.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, NgControl } from '@angular/forms';
import { Component, OnInit, Self } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';``

@Component({
    selector: 'minster-number-picker',
    standalone: true,
    imports: [FormsModule, MatFormFieldModule, MatInputModule, MatTooltipModule, MatIconModule],
    templateUrl: './minster-number-picker.component.html',
    styleUrls: ['./minster-number-picker.component.css'],
    providers: [{ provide: ControlBaseComponent, useExisting: MinsterNumberPickerComponent }]
})

export class MinsterNumberPickerComponent extends ControlBaseComponent<number> implements OnInit {
     constructor(@Self() public controlDir: NgControl, stateService: StateService) {
        super(controlDir, stateService);
    }

    ngOnInit(): void {
         this.setup();
    }

    valueUpdated(newValue: any): void {
        this._value = newValue;
        this._propagateChange(this._value);
    }

    onBlur(): void {
        if (this._value == null) {
            this._value = 0; 
            this._propagateChange(this._value);
        }
    }
}